module.exports = __webpack_public_path__ + "static/media/lana-del-rey-win.88d57d5a.jpg";